import React from "react";
import { connect } from "react-redux";
import * as agent from "../agent";
import { reduxForm, Field, formValueSelector } from "redux-form";
import { NewLoanTypes, Office, Masks } from "../constants/enums";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import MaterialCombobox from "./MaterialCombobox";
import { CLIENT_LOADED } from "../constants/actionTypes";
import { normalizeMoney } from "../utility";
import SubmitButton from "./SubmitButton";
import Grid from "@material-ui/core/Grid";
import InnerLink from "./InnerLink";
import Fade from "@material-ui/core/Fade";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import PrimaryDivider from "./PrimaryDivider";

const editCarForm = ({
    brands,
    models,
    suggestionsLoaded,
    car,
    editCar,
    handleSubmit
}) => {
    return (
        <form
            className="common-form common-column"
            onSubmit={handleSubmit(data => editCar(car._id, data))}
        >
            <Field
                name="brand"
                component={MaterialCombobox}
                suggestionsLoaded={suggestionsLoaded}
                suggestions={Object.keys(brands)}
                label="Марка автомобиля"
            />
            <Field
                name="model"
                component={MaterialCombobox}
                suggestionsLoaded={suggestionsLoaded}
                suggestions={models}
                label="Модель автомобиля"
            />
            <Field
                name="year"
                component={MaterialMaskedTextField}
                mask={Masks.year}
                label="Год выпуска"
            />
            <Field
                component={MaterialTextField}
                name="loan.value"
                format={normalizeMoney}
                normalize={normalizeMoney}
                endAdornment="₽"
                label="Сумма займа"
            />
            <Field
                name="loan.type"
                select
                component={MaterialTextField}
                label="Программа"
            >
                {Object.keys(NewLoanTypes).map((t, i) => (
                    <MenuItem key={i} value={t}>
                        {NewLoanTypes[t]}
                    </MenuItem>
                ))}
            </Field>
            <Field
                name="loan.office"
                select
                component={MaterialTextField}
                label="Офис"
            >
                {Object.keys(Office).map((o, j) => (
                    <MenuItem key={j} value={o}>
                        {Office[o]}
                    </MenuItem>
                ))}
                <MenuItem value="NOT_SURE">Не определился</MenuItem>
            </Field>
            <SubmitButton label="Сохранить" />
        </form>
    );
};

const EditCarForm = connect((state, props) => {
    const { brands } = props;
    const { client = {} } = state;
    const brand = formValueSelector("edit-car-form")(state, "brand");

    const car = ((client.client || {}).cars || []).find(
        c => c._id === client.carId
    );
    return {
        models: (brands[brand] || []).map(m => m.model),
        car,
        initialValues: car
    };
})(
    reduxForm({
        form: "edit-car-form",
        enableReinitialize: true
    })(editCarForm)
);

class EditCar extends React.Component {
    state = {
        brands: [],
        suggestionsLoaded: false
    };

    componentWillMount() {
        const { clientId, onLoad } = this.props;
        agent.Client.get(clientId)
            .then(onLoad)
            .catch(e => alert(e.message));

        agent.Cars.brands()
            .then(res => {
                this.setState({ brands: res, suggestionsLoaded: true });
            })
            .catch(e => alert(e));
    }

    editCar = (id, data) => {
        agent.Clients.editCar(
            id,
            Object.assign({}, data, {
                loan: { value: Number(data.loan.value.replace(/\s/g, ``)) }
            })
        )
            .then(client => this.setState({ client }))
            .then(() => alert("Данные успешно сохранены"))
            .catch(e => alert(e.message));
    };

    render() {
        const { clientId } = this.props;
        const { brands, suggestionsLoaded } = this.state;
        return (
            <Fade in={true}>
                <React.Fragment>
                    <Typography variant="h4">Редактировать заявку</Typography>
                    <PrimaryDivider />
                    <Grid container justify="flex-start">
                        <Grid item>
                            <Paper className="common-paper">
                                <EditCarForm
                                    brands={brands}
                                    suggestionsLoaded={suggestionsLoaded}
                                    editCar={this.editCar}
                                />
                                <InnerLink
                                    href={`/client/${clientId}`}
                                    label="Редактировать клиента"
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </React.Fragment>
            </Fade>
        );
    }
}

const mapStateToProps = (state, { match }) => ({
    clientId: match.params.clientId,
    carId: match.params.carId
});

const mapDispatchToProps = (dispatch, { match }) => ({
    onLoad: client =>
        dispatch({
            type: CLIENT_LOADED,
            payload: {
                ...client,
                id: match.params.clientId,
                carId: match.params.carId
            }
        }),
    editClient: (id, data) => {
        agent.Clients.editCar(id, data)
            .then(client => dispatch({ type: CLIENT_LOADED, payload: client }))
            .then(() => alert("Данные успешно сохранены"));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(EditCar);



// WEBPACK FOOTER //
// ./src/components/EditCar.js